<template>
  <div>
    <h1>Partnerlogin</h1>
    <h4>{{ $t("login") }}</h4>
    <p class="widget-auth-info">
      {{ $t("useYourEmailToLogin") }}
    </p>
    <login-form redirect-route="partnerdashboard" />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "LoginPartnerView",
  components: {
    LoginForm
  }
};
</script>

<style scoped lang="scss"></style>
